export default {
  label: {
    dashboardSelectlabel: 'Dashboard',
    dashboardSelectPlaceholder: 'Seleccione un dashboard',
    noTitleDashboard: 'Dashboard sin título',
    isStagingTooltip: 'Esta investigación pertenece al entorno de prueba (staging)',
  },
};
